/**
 * Step-by-step bubble arrow component.
 * Renders a downward-pointing arrow for the hopscotch bubble with fixed positioning.
 * @returns {JSX.Element}
 */
export default function StepArrow() {
  return (
    <div className="hopscotch-bubble-arrow-container hopscotch-arrow down" style={{ bottom: "-34px", left: "10px" }} data-testid="hopscotch-arrow">
      <div className="hopscotch-bubble-arrow-border"></div>
      <div className="hopscotch-bubble-arrow"></div>
    </div>
  )
}
